import React, { PropsWithChildren } from "react";

import { clsx } from "clsx";

type Props = {
  theme?: "light" | "dark";
  visibility?: boolean | true;
  size?: string;
  className?: string;
  close?: () => void;
};

const Modal = ({
  size,
  visibility,
  className,
  theme,
  children,
  close,
}: PropsWithChildren<Props>) => (
  <>
    {visibility && (
      <>
        <div
          className={clsx({
            modal: true,
            fade: true,
            [`${className ? className : ""}`]: className,
          })}
        >
          <div
            className={clsx({
              "modal-dialog": true,
              [`${size ? "modal-" + size : ""}`]: size,
            })}
          >
            <div
              className={clsx({
                "modal-content": true,
                dark: theme === "dark",
                light: theme === "light",
              })}
            >
              {children}
            </div>
            <div className="modal-backdrop" onClick={close && close} />
          </div>
        </div>
      </>
    )}
  </>
);

Modal.Header = ({ children }: PropsWithChildren<Props>) => (
  <div className="modal-header">{children}</div>
);

Modal.Title = ({ children }: PropsWithChildren<Props>) => (
  <h3 className="modal-title">{children}</h3>
);

Modal.Body = ({ className, children }: PropsWithChildren<Props>) => {
  return (
    <div
      className={clsx({
        "modal-body": true,
        [`${className ? className : ""}`]: className,
      })}
    >
      {children}
    </div>
  );
};

Modal.Footer = ({ children }: PropsWithChildren<Props>) => (
  <div className="modal-footer">{children}</div>
);

Modal.Actions = ({ children }: PropsWithChildren<Props>) => (
  <div className="modal-actions">{children}</div>
);

export default Modal;
